import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../images/gray/tag.svg";

const TagIcon = (props) => {
  return (
    <Wrapper onClick={props.onClick}>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default TagIcon;
